import AbstractView = require("./abstract/AbstractView");


class LoadingView extends AbstractView{
    constructor(template: JQuery) {
        super(template);
    }

    private $progress: JQuery;
    private $percentText: JQuery;

    public init(): void {
        this.$progress = this.$template.find(".progress");
        this.$percentText = this.$progress.find(".percent");
    }

    public onProgress(percent: number): void {
        this.$percentText.html(percent.toString() + "%");
    }

    public reset(): void {
        this.$percentText.html("0");
    }
}

export = LoadingView;